import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["searchInput", "row", "emptyMessage", "countryCheckbox", "selectAllCheckbox"];

  connect() {
    this.syncSelectAll();
  }

  filter() {
    const query = this.hasSearchInputTarget
      ? this.searchInputTarget.value.trim().toLowerCase()
      : "";
    const selectedCountries = this.selectedCountryCodes();
    let visibleCount = 0;

    this.rowTargets.forEach((row) => {
      const text = (row.dataset.searchText || "").toLowerCase();
      const searchMatch = !query || text.includes(query);
      const countryCode = row.dataset.countryCode || "";
      const countryMatch =
        selectedCountries.length === 0 || selectedCountries.includes(countryCode);
      const visible = searchMatch && countryMatch;
      row.classList.toggle("hidden", !visible);
      if (visible) visibleCount += 1;
    });

    if (this.hasEmptyMessageTarget) {
      this.emptyMessageTarget.classList.toggle("hidden", visibleCount > 0);
    }

    this.syncSelectAll();
    this.dispatch("filtered");
  }

  toggleAll() {
    const checked = this.selectAllCheckboxTarget.checked;
    this.visibleRowCheckboxes().forEach((checkbox) => {
      checkbox.checked = checked;
    });
  }

  syncSelectAll() {
    if (!this.hasSelectAllCheckboxTarget) return;

    const checkboxes = this.visibleRowCheckboxes();
    const checkedCount = checkboxes.filter((checkbox) => checkbox.checked).length;

    this.selectAllCheckboxTarget.checked =
      checkboxes.length > 0 && checkedCount === checkboxes.length;
    this.selectAllCheckboxTarget.indeterminate =
      checkedCount > 0 && checkedCount < checkboxes.length;
  }

  visibleRowCheckboxes() {
    return this.rowTargets
      .filter((row) => !row.classList.contains("hidden"))
      .map((row) => row.querySelector('input[type="checkbox"]'))
      .filter(Boolean);
  }

  selectedCountryCodes() {
    if (!this.hasCountryCheckboxTarget) return [];

    return this.countryCheckboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);
  }
}
